/* @flow */

// these must be set in .env:

export const API_URL = process.env.REACT_APP_API_URL;
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;
export const API_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const ESTIMATE_PAGE_PATH = process.env.REACT_APP_ESTIMATE_PAGE_PATH;
export const ONBOARDIQ_API_KEY = process.env.REACT_APP_ONBOARDIQ_API_KEY;
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;



// WEBPACK FOOTER //
// ./src/Constants.js